import React, { useState } from 'react'
import { getPassword } from '../api/apiCalls'
import getNonce from '../../lib/functions/getNonce'
import PasswordForm from './PasswordForm'
import PasswordSent from './PasswordSent'
import PasswordLoading from './PasswordLoading'

const PassowrdAjax = () => {
    const [isLoading, setIsLoading] = useState(false)
    const [hasSent, setHasSent] = useState(false)
    const [hasError, setHasError] = useState(false)


    const onSubmitForm = (values) => {
        setIsLoading(true)
        setHasSent(true)

        const nonce = getNonce()
        const data = {
            email: values.email.toLowerCase()
        }
       
        if(!nonce) {
            setHasError(true)
            setIsLoading(false)
        } else {
            getPassword(nonce, data)
                .then(
                    (result) => {},
                    (error) => {
                        setHasError(true)
                    }
                )
                .then(() => {
                    setIsLoading(false)
                })
        }
    }

    const onTryAgain  = ()  => {
        location.reload()
    }

    return (
        isLoading ? (
            <PasswordLoading />
        ) : hasSent ? (
            <PasswordSent
                hasError={hasError}
                onTryAgain={onTryAgain}
            />
        ) : (
            <PasswordForm
                onSubmitForm={onSubmitForm}
            />
        )
    )
}

export default PassowrdAjax